import React, { Component } from 'react'

export default class Display extends Component {
  render() {
    const { label, onChange, options } = this.props;
    return (
      <div className="display-option">
          <div className="form-field">
            <label className="label">{label}</label>
            <select onChange={onChange}>
              {options.map(item => <option key={item} value={item}>{item}</option>)}
            </select>
          </div>
        </div>
    )
  }
}
